/**
 * Facebook Sharing Utilities
 * Helper functions for sharing to Neighbours Pantry Facebook group
 */

const FACEBOOK_GROUP_ID = '1483887879720908';
const FACEBOOK_GROUP_URL = `https://www.facebook.com/groups/${FACEBOOK_GROUP_ID}`;

/**
 * Share honesty box details to Facebook group
 * @param {Object} box - Box details
 * @param {string} actionType - Type of action: 'new', 'update', 'bump'
 */
export const shareBoxToFacebook = (box, actionType = 'new') => {
  const baseUrl = window.location.origin;
  
  let message = '';
  let hashtags = '#NeighboursPantry #HonestyBox #SunshineCoast';
  
  switch (actionType) {
    case 'new':
      message = `🌱 NEW Honesty Box Alert! 🌱\n\n` +
                `${box.name}\n\n` +
                `${box.description}\n\n` +
                `📍 ${box.address}\n` +
                `${box.hours ? `⏰ ${box.hours}\n` : ''}` +
                `${box.contact_info ? `📞 ${box.contact_info}\n` : ''}\n` +
                `Find us on the Neighbours Pantry map!\n\n` +
                hashtags;
      break;
      
    case 'update':
      message = `✨ Updated! ✨\n\n` +
                `${box.name}\n\n` +
                `We've updated our honesty box details:\n` +
                `${box.description}\n\n` +
                `📍 ${box.address}\n` +
                `${box.hours ? `⏰ ${box.hours}\n` : ''}\n` +
                `${box.contact_info ? `📞 ${box.contact_info}\n` : ''}\n` +
                `Check it out on the Neighbours Pantry map!\n\n` +
                hashtags;
      break;
      
    case 'bump':
      message = `🔄 Still Open & Stocked! 🔄\n\n` +
                `${box.name}\n\n` +
                `${box.description}\n\n` +
                `📍 ${box.address}\n` +
                `${box.hours ? `⏰ ${box.hours}\n` : ''}\n` +
                `Visit us today! Find us on the Neighbours Pantry map.\n\n` +
                hashtags;
      break;
      
    default:
      message = `${box.name}\n\n${box.description}\n\n📍 ${box.address}\n\n` + hashtags;
  }
  
  // Facebook share dialog URL
  const shareUrl = `https://www.facebook.com/groups/${FACEBOOK_GROUP_ID}`;
  const facebookUrl = `https://www.facebook.com/dialog/share?` +
    `app_id=966242223397117&` + // Generic app ID for testing
    `display=popup&` +
    `href=${encodeURIComponent(baseUrl)}&` +
    `quote=${encodeURIComponent(message)}`;
  
  // Open Facebook share dialog in popup
  window.open(
    facebookUrl,
    'facebook-share-dialog',
    'width=800,height=600'
  );
};

/**
 * Share vendor profile update to Facebook group
 * @param {Object} profile - Vendor profile details
 */
export const shareProfileToFacebook = (profile) => {
  const message = `👋 Meet Our Vendor! 👋\n\n` +
                  `${profile.business_name || 'Local Producer'}\n\n` +
                  `${profile.bio || 'Supporting local community with fresh produce and goods!'}\n\n` +
                  `${profile.payment_methods.length > 0 ? `💰 Payment: ${profile.payment_methods.join(', ')}\n` : ''}` +
                  `${profile.contact_email ? `📧 ${profile.contact_email}\n` : ''}` +
                  `${profile.website ? `🌐 ${profile.website}\n` : ''}\n` +
                  `Find our honesty boxes on the Neighbours Pantry map!\n\n` +
                  `#NeighboursPantry #LocalProducer #SunshineCoast`;
  
  const baseUrl = window.location.origin;
  const facebookUrl = `https://www.facebook.com/dialog/share?` +
    `app_id=966242223397117&` +
    `display=popup&` +
    `href=${encodeURIComponent(baseUrl)}&` +
    `quote=${encodeURIComponent(message)}`;
  
  window.open(
    facebookUrl,
    'facebook-share-dialog',
    'width=800,height=600'
  );
};

/**
 * Direct link to post in Facebook group
 */
export const openFacebookGroup = () => {
  window.open(FACEBOOK_GROUP_URL, '_blank', 'noopener,noreferrer');
};

export { FACEBOOK_GROUP_URL };
